import { DateUtils } from '../../../services/date-utils.service'

export class EjsTimepickerUtils {
  static ensureStringTimeHHdelimMMFormat(date: Date | string): string {
    console.log('ensureStringTimeHHdelimMMFormat', date)
    if (DateUtils.canBeParsedToDate(date)) {
      return DateUtils.dateToHhColonMm(new Date(date))
    }
    return date.toString()
  }
}
